import { Controller } from "@hotwired/stimulus";

// Reloads the enclosing turbo-frame on window focus, so the price field appears
// after the organiser connects Stripe in another tab and returns.
export default class extends Controller {
  static values = { url: String };

  connect() {
    this.reload = this.reload.bind(this);
    window.addEventListener("focus", this.reload);
  }

  disconnect() {
    window.removeEventListener("focus", this.reload);
  }

  reload() {
    const frame = this.element.closest("turbo-frame");
    if (frame) frame.src = this.urlValue;
  }
}
